<div class="item-request-data-number d-flex flex-row col-12 text-break text-wrap">
    <div class="d-flex flex-column col-3">
        <h3 class="mat-caption item-title foreground-disabled-text mb-0">{{ awbLabel }}</h3>
        <div class="d-flex align-items-center">
            @if (showIcon) {
                <mat-icon color="accent" class="material-symbols-outlined md-icon-18 alert-icon pe-2">
                    warning_amber
                </mat-icon>
            }
            <span class="item-value mat-subtitle-1 mb-0">{{ item.hawb ? item.hawb : item.awb }}</span>
        </div>
    </div>
    @if (calculateQuantityByExtraItems && quantity) {
        <div class="d-flex flex-column pe-1 flex-grow-1 col-2">
            <h3 class="mat-caption item-title foreground-disabled-text mb-0">Quantity</h3>
            <span class="item-value mat-subtitle-1 mb-0 text-wrap">{{ quantity || '' }} </span>
        </div>
    }
    <div
        class="d-flex flex-column pe-1 flex-grow-1 col-2"
        [ngClass]="{ 'col-3': !calculateQuantityByExtraItems || !quantity }"
    >
        <h3 class="mat-caption item-title foreground-disabled-text mb-0">Payment type</h3>
        <span class="item-value mat-subtitle-1 mb-0 text-wrap">
            {{ item.externalData?.paymentType }}
        </span>
    </div>
    @if (item.customerReference) {
        <div
            class="d-flex flex-column pe-1 flex-grow-1 col-2"
            [ngClass]="{ 'col-3': !calculateQuantityByExtraItems || !quantity }"
        >
            <h3 class="mat-caption item-title foreground-disabled-text mb-0">
                {{ customerReferenceLabel }}
            </h3>
            <span class="item-value mat-subtitle-1 mb-0 text-wrap">
                {{ item.customerReference }}
            </span>
        </div>
    }
    <div class="d-flex flex-column col-3">
        <h3 class="mat-caption item-title foreground-disabled-text mb-0 text-end">Amount</h3>
        <span class="item-value mat-subtitle-1 mb-0 item-amount text-wrap text-end">
            {{ item.amount | currency }}
        </span>
    </div>
</div>
